import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useFormikContext } from 'formik';

import './InputText.scss';

const InputText = ({
  name, label, isMultiple, prefix,
}) => {
  const [focused, setFocused] = useState(false);
  const {
    values, setFieldValue, setFieldTouched, errors, touched,
  } = useFormikContext();
  const fieldValue = values[name];
  const error = errors[name] && touched[name] ? errors[name] : null;

  const params = {
    id: name,
    name,
    type: 'text',
    className: classnames('form-field__input', {
      error: !!error,
      'with-prefix': !!prefix,
    }),
    value: fieldValue,
    onChange: (event) => {
      setFieldValue(name, event.target.value);
    },
    onFocus: () => {
      setFocused(true);
    },
    onBlur: () => {
      setFocused(false);
      setFieldTouched(name, true);
    },
  };

  if (isMultiple) {
    params.rows = 5;
  }

  return (
    <div className="input-text">
      <div
        className={classnames('form-field', {
          'form-field--is-active': focused || fieldValue !== '' || !!prefix,
        })}
      >
        <div className="form-field__control">
          <label
            htmlFor={name}
            className={classnames('form-field__label', {
              error: !!error,
            })}
          >
            {label}
          </label>
          {
            isMultiple ? (
              <textarea {...params} />
            ) : (
              <input {...params} />
            )
          }
          {
            prefix && (
              <div className="prefix">
                {prefix}
              </div>
            )
          }
        </div>
        {
          error && (
            <div className="field-error">
              {error}
            </div>
          )
        }
      </div>
    </div>
  );
};

InputText.propTypes = {
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  isMultiple: PropTypes.bool,
  prefix: PropTypes.node,
};

InputText.defaultProps = {
  isMultiple: false,
  prefix: null,
};

export default InputText;
